<template>

<MenuLinks />

<router-view />

</template>

<script>
import MenuLinks from '@/components/MenuLinks';

export default {
  name: 'App',
  components: {
    MenuLinks,
  },
  setup () {

  },
};
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css2?family=Kalam&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cabin+Sketch&display=swap');
@font-face
  font-family TrainOne
  font-weight 400
  src url(../src/css/fonts/TrainOne-Regular.ttf)

//
// Averta
@font-face
  font-family Averta
  font-weight 300
  src url(../src/css/fonts/AvertaCY-Light.woff2)

@font-face
  font-family Averta
  font-weight 400
  src url(../src/css/fonts/AvertaCY-Regular.woff2)

@font-face
  font-family Averta
  font-weight 500
  src url(../src/css/fonts/AvertaCY-Semibold.woff2)

@font-face
  font-family AvertaStd
  font-weight 600
  src url(../src/css/fonts/AvertaStd-Bold.otf)

//
// Montserrat
@font-face
  font-family Montserrat
  font-weight 300
  src url(../src/css/fonts/montserrat/Montserrat-Light.ttf)

@font-face
  font-family Montserrat
  font-weight 400
  src url(../src/css/fonts/montserrat/Montserrat-Regular.ttf)

@font-face
  font-family Montserrat
  font-weight 500
  src url(../src/css/fonts/montserrat/Montserrat-Medium.ttf)

@font-face
  font-family Montserrat
  font-weight 600
  src url(../src/css/fonts/montserrat/Montserrat-SemiBold.ttf)

@font-face
  font-family Montserrat
  font-weight 700
  src url(../src/css/fonts/montserrat/Montserrat-Bold.ttf)

/*! minireset.css v0.0.6 | MIT License | github.com/jgthms/minireset.css */
html,
body,
p,
ol,
ul,
li,
dl,
dt,
dd,
blockquote,
figure,
fieldset,
legend,
textarea,
pre,
iframe,
hr,
h1,
h2,
h3,
h4,
h5,
h6
  margin: 0;
  padding: 0;

h1,
h2,
h3,
h4,
h5,
h6
  font-size: 100%;
  font-weight: normal;

ul
  list-style: none;

button,
input,
select
  margin: 0;

html
  box-sizing: border-box;

*, *::before, *::after
  box-sizing: border-box;

img,
video
  height: auto;
  max-width: 100%;

iframe
  border: 0;

table
  border-collapse: collapse;
  border-spacing: 0;

td,
th
  padding: 0;

#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
  #nav
    z-index 1000
    position absolute
    top 0
    left 50%

</style>